export const formatLeadToText = (lead) => {

  return `
Lead No: ${lead.lead_no || "-"}

Name: ${lead.contact_name || "-"}
Company: ${lead.company_name || "-"}
Phone: ${lead.phone || "-"}
Email: ${lead.email || "-"}
Address: ${lead.address || "-"}

Source: ${lead.source || "-"}
Status: ${lead.status || "-"}

Notes:
${lead.notes || "-"}
`.trim();

};